import "../styles/Header.css";
import React, { Component } from "react";
import mainLogo from '../img/media_place.png';
import topImg from '../img/top.png';
import Info from '../pages/Info';
import { OverlayTrigger, Tooltip } from "react-bootstrap";

class Header extends Component {

    renderTooltip = () => (
        <Tooltip id="button-tooltip">
            <Info />
        </Tooltip>
    );

    render() {
        return (
            <header className="main-header" style={{ backgroundImage: `url(${topImg})` }}>
                <OverlayTrigger
                    placement="right"
                    delay={{ show: 250, hide: 600 }}
                    overlay={this.renderTooltip()}
                >
                    <a aria-current="page" className="logo active" id="logo" href="/eoplaty/">
                        <img src={mainLogo} alt="eKadry" />
                        <span className="logo-lg">eOpłaty</span>
                    </a>
                </OverlayTrigger>
            </header >
        )
    }
}

export default Header